module.exports = __webpack_public_path__ + "img/argirEtArco.3561f411.png";